<ng-container *ngIf="!renderAsLink; then buttonView else linkView"></ng-container>
<ng-template #contentView>
  <ng-content select="[start]"></ng-content>
  <ng-content></ng-content>
  <ng-content select="[end]"></ng-content>
</ng-template>

<ng-template #buttonView>
  <button class="flex flex-row gap-3 flex-nowrap items-center m-0 justify-center rounded-full text-sm leading-tight font-bold antialiased"
          [ngClass]="className"
          [class.w-full]="fullWidth"
          [class.disabled]="state"
          [attr.type]="type">
    <ng-container [ngTemplateOutlet]="contentView"></ng-container>
  </button>
</ng-template>

<ng-template #linkView>
  <a class="flex flex-row gap-3 flex-nowrap items-center m-0 justify-center rounded-full text-sm leading-tight font-bold antialiased"
     [ngClass]="className"
     [href]="href"
     [class.disabled]="state">
    <ng-container [ngTemplateOutlet]="contentView"></ng-container>
  </a>
</ng-template>

